import { render, staticRenderFns } from "./channeldetail.vue?vue&type=template&id=2ff251b1&scoped=true&"
import script from "./channeldetail.vue?vue&type=script&lang=js&"
export * from "./channeldetail.vue?vue&type=script&lang=js&"
import style0 from "./channeldetail.vue?vue&type=style&index=0&id=2ff251b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff251b1",
  null
  
)

export default component.exports